


import style from './HomePageTemp.module.css'

import React, { useEffect, useState } from 'react';



import { Navigation, Pagination, Scrollbar, A11y, FreeMode, Thumbs, EffectFade, Autoplay, } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';







import leftImg from '../component/media/homepage-images/left-image.png'
import lebanon from '../component/media/countries/lebanon.png'
import usa from '../component/media/countries/usa.png'
import australia from '../component/media/countries/australia.png'


import featureIcon1 from '../component/media/homepage-images/features-icon-1.png'
import featureIcon2 from '../component/media/homepage-images/features-icon-2.png'
import featureIcon3 from '../component/media/homepage-images/features-icon-3.png'
import featureIcon4 from '../component/media/homepage-images/features-icon-4.png'
//import leftImg from '../component/media/homepage-images/left_image.png'

import { BsInstagram, BsWhatsapp } from 'react-icons/bs'
import { FaFacebookF } from 'react-icons/fa'
import { Link } from 'react-router-dom';




const services=[{
title:'1. Online Tutoring',
description:'Our global online tutoring service connects you with expert tutors who personalize their teaching to match your unique learning needs, helping you excel in your studies. Get access to online follow-up and session notes.',
img:featureIcon2,

},


{
    title:'2. Crash Courses for Exam Success',
    description:'Join our online group tutoring sessions designed to prepare you for exams. Access practice exams and questions similar to your upcoming tests. Benefit from an intensive course with extra support and unlimited questions.',
    img:featureIcon4,
    
    },


    {
        title:'3. Lebanon-Based In-Home Tutoring',
        description:'Our experienced tutors come to your doorstep in Lebanon to provide personalized assistance with subjects, study strategies, and educational support. We also offer the convenience of online tutoring.',
        img:featureIcon3,
        
        },]



const countries=[{
image:australia,
phone:"+61 475 504 568",
name:"Australia",

},

{
    image:lebanon,
    phone:"+961 81 184 763",
    name:"Lebanon",
    
    },

    {
        image:usa,
        phone:"+1 929 532 4355",
        name:"America",
        
        },

]





export default function HomePage() {

    
  
    return (
        <div className={style.body}>


            <div className={style.welcome_area} id={style.welcome}>
                <div className={style.header_text}>
                    <div className="container">
                        <div className="row">
                            <div className={style.left_text + " col-lg-5 col-md-12 col-sm-12 col-xs-12"}
                                data-scroll-reveal="enter left move 30px over 0.6s after 0.4s">
                                <h1>Study made easy with <em>QUESTA</em></h1>
                                <p>Questa is an AI enhanced Q&A platform that offers students while studying <b>swift answers</b> from <b>real teachers</b> in <b>all subjects</b> in a <b>cost-effective</b> manner.</p>
                                <p>Utilizing AI, we <b>personalize the learning experience</b> by identifying each student's <b>unique educational requirements</b> and tailoring our platform to optimize their learning journey. </p>
                                <Link to='/ask' className={style.main_button_slider}>ask a question now</Link>   

 </div>
                        </div>
                    </div>
                </div>

            </div>


            <div className={style.left_image_decor}></div>
            <section className={style.section} id={style.promotion}>
                <div className="container">
                    <div className="row">
                        <div className={style.left_image + " col-lg-5 col-md-12 col-sm-12 mobile_bottom_fix_big   wow fadeInLeft"}
                         data-wow-delay="0.5s"  >
                            <img src={leftImg} className="rounded img-fluid d-block mx-auto" alt="App" />
                        </div>
                        <div className={style.right_text + " offset-lg-1 col-lg-6 col-md-12 col-sm-12 " + style.mobile_bottom_fix}>
                            <ul>
                               



                               {

                                services.map((n,index) => {
                                    return <li data-scroll-reveal="enter right move 30px over 0.6s after 0.4s">
                                <div className=" d-flex align-items-center wow fadeInRight"    data-wow-delay="0.5s"  >

                                    <img src={n.img} alt="" />

                                    <div className="text">
                                        <h4>{n.title}</h4>
                                        <p>{n.description}</p>
                                    </div>

                                </div>
                            </li>})
                               }


                               
                            </ul>
                        </div>
                    </div>
                </div>
            </section>


            <section className={style.our_services_2 + " section-margin"} data-dsn="color">


                <div className="container">
                    <h2 className={style.title_main}>countries we operate in</h2>




                    <Swiper
            
            spaceBetween={5}
            slidesPerView={1}
            breakpoints={{
                1240: {
                    width: 1240,
                    slidesPerView: 4,
                },
                // when window width is >= 640px

                940: {
                    width: 940,
                    slidesPerView: 3,
                },
                // when window width is >= 768px
                768: {
                    width: 768,
                    slidesPerView: 2,
                },
            }}
            // freeMode={true}
            loop={true}

            autoplay={{
                delay: 4000,
                disableOnInteraction: false
            }}
            watchSlidesProgress={true}
            modules={[FreeMode, Navigation, Thumbs, EffectFade, Autoplay,Scrollbar,Pagination,]}

           
            className="mySwiper2"
        >

            {countries.map((n, index) => {
                return <SwiperSlide key={index}>
                <div className={style.services_item}>



<div className="row ">


    <div className="col-3teo  col-md-12teo col-12 no-padding">
        <div className={style.icon}>
            <img src={n.image} alt="" />
        </div>

    </div>
    <div className="col-9teo  col-md-12teo col-12 no-padding">
        <div className={style.services_header + " align-self-start"}>
            <h3>{n.name}</h3>
        </div>
        <p ><a className={style.phoneLinkButton}  href={`tel:${n.phone}`}>{n.phone}</a></p>

    </div>
</div>
</div>
                </SwiperSlide>
            })}




        </Swiper>



                  
                </div>
            </section>

            <div className={style.right_image_decor}></div>


            <section className={style.section} id={style.testimonials}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2">
                            <div className={style.center_heading}>
                                <h2>What Is Our<em> Mission</em></h2>
                                <p>Transforming Learning, One Question at a Time, because we care deeply about improving students' academic journey.</p>

                            </div>
                        </div>

                    </div>
                </div>
            </section>




            <div id={style.contact_us}>
                <div className="container">
                    <div className={style.footer_content}>
                        <div className="row">


                            <div className={style.right_content + " col-12"}>
                                <h2>More About <em>QUESTA</em></h2>
                                <p>If you want to connect with us, you may follow or contact us
                                    for more detail.</p>
                                <ul className={style.social}>

                                <li><a href='https://www.instagram.com/questa.education/'><BsInstagram /></a></li>
                                    <li><a href='https://wa.me/96181184763?text=Hello,%20I%20am%20interested%20in%20your%20services' ><BsWhatsapp /></a></li>
                                    <li><a href='https://www.facebook.com/questa.education/'><FaFacebookF /></a></li>

                                    {/* <li><a rel="nofollow" target='_blank' href="https://www.instagram.com/questa.education/"><BsInstagram /></a></li>
                                    <li><a rel="nofollow" target='_blank' href="https://wa.me/message/EQMDVYMG5NXJK1"><BsWhatsapp /></a></li>
                                    <li><a href="https://www.facebook.com/questa.education/"><FaFacebookF /></a></li> */}

                                </ul>
                            </div>



                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className={style.sub_footer}>
                                    <p>Copyright &copy;{new Date().getFullYear().toString()} Questa

                                        | Designed by <a rel="nofollow" href="https://moondev-digital-agency.netlify.app/">moondev</a></p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )
}

